import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/global.png'
import _imports_1 from '../images/global-map.png'
import _imports_2 from '../images/map-message-1.png'
import _imports_3 from '../images/map-message-2.png'
import _imports_4 from '../images/map-message-3.png'
import _imports_5 from '../images/map-message-4.png'
import _imports_6 from '../images/map-message-5.png'
import _imports_7 from '../images/map-message-6.png'
import _imports_8 from '../images/plastics-title-bg.png'
import _imports_9 from '../images/closed.png'


const _withScopeId = n => (_pushScopeId("data-v-3d2ff6c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "global"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-con" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "title" }, "GLOBAL PRESENCE")
], -1))
const _hoisted_4 = { class: "map-box" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "map",
  src: _imports_1,
  alt: "otimes global-map"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-1" }, "Corporate Headquarters", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-2" }, "Local presence", -1))
const _hoisted_8 = {
  key: 0,
  class: "map-msg-one",
  src: _imports_2,
  alt: "otimes map-message-1"
}
const _hoisted_9 = {
  key: 1,
  class: "map-msg-two",
  src: _imports_3,
  alt: "otimes map-message-2"
}
const _hoisted_10 = {
  key: 2,
  class: "map-msg-three",
  src: _imports_4,
  alt: "otimes map-message-3"
}
const _hoisted_11 = {
  key: 3,
  class: "map-msg-four",
  src: _imports_5,
  alt: "otimes map-message-4"
}
const _hoisted_12 = {
  key: 4,
  class: "map-msg-five",
  src: _imports_6,
  alt: "otimes map-message-5"
}
const _hoisted_13 = {
  key: 5,
  class: "map-msg-six",
  src: _imports_7,
  alt: "otimes map-message-6"
}
const _hoisted_14 = {
  key: 0,
  class: "mask"
}
const _hoisted_15 = { class: "contact-con-two" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "top-img",
  src: _imports_8,
  alt: "plastics-title-bg"
}, null, -1))
const _hoisted_17 = { class: "confirmation" }
const _hoisted_18 = { class: "usermation" }
const _hoisted_19 = { class: "name-box" }
const _hoisted_20 = { class: "name-con" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "First name *", -1))
const _hoisted_22 = { class: "name-con" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Last name *", -1))
const _hoisted_24 = { class: "mail-box" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mail" }, "Email address *", -1))
const _hoisted_26 = { class: "text-con" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "content" }, "Content *", -1))
const _hoisted_28 = { class: "button-box" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Send")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_BackTop = _resolveComponent("BackTop")!
  const _component_ChatBox = _resolveComponent("ChatBox")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_CookieBox = _resolveComponent("CookieBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TopBar),
    _hoisted_2,
    _createVNode(_component_Breadcrumb),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      (_ctx.msgTagOne)
        ? (_openBlock(), _createElementBlock("img", _hoisted_8))
        : _createCommentVNode("", true),
      (_ctx.msgTagTwo)
        ? (_openBlock(), _createElementBlock("img", _hoisted_9))
        : _createCommentVNode("", true),
      (_ctx.msgTagThree)
        ? (_openBlock(), _createElementBlock("img", _hoisted_10))
        : _createCommentVNode("", true),
      (_ctx.msgTagFour)
        ? (_openBlock(), _createElementBlock("img", _hoisted_11))
        : _createCommentVNode("", true),
      (_ctx.msgTagFive)
        ? (_openBlock(), _createElementBlock("img", _hoisted_12))
        : _createCommentVNode("", true),
      (_ctx.msgTagSix)
        ? (_openBlock(), _createElementBlock("img", _hoisted_13))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "map-point-one",
        onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.msgTagOne = 1)),
        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.msgTagOne = 0))
      }, null, 32),
      _createElementVNode("div", {
        class: "map-point-two",
        onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.msgTagTwo = 1)),
        onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.msgTagTwo = 0))
      }, null, 32),
      _createElementVNode("div", {
        class: "map-point-three",
        onMouseover: _cache[4] || (_cache[4] = ($event: any) => (_ctx.msgTagThree = 1)),
        onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.msgTagThree = 0))
      }, null, 32),
      _createElementVNode("div", {
        class: "map-point-four",
        onMouseover: _cache[6] || (_cache[6] = ($event: any) => (_ctx.msgTagFour = 1)),
        onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (_ctx.msgTagFour = 0))
      }, null, 32),
      _createElementVNode("div", {
        class: "map-point-five",
        onMouseover: _cache[8] || (_cache[8] = ($event: any) => (_ctx.msgTagFive = 1)),
        onMouseleave: _cache[9] || (_cache[9] = ($event: any) => (_ctx.msgTagFive = 0))
      }, null, 32),
      _createElementVNode("div", {
        class: "map-point-six",
        onMouseover: _cache[10] || (_cache[10] = ($event: any) => (_ctx.msgTagSix = 1)),
        onMouseleave: _cache[11] || (_cache[11] = ($event: any) => (_ctx.msgTagSix = 0))
      }, null, 32)
    ]),
    _createElementVNode("div", {
      class: "button",
      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.contactTag = 1))
    }, "Click to get in touch with our local affiliate."),
    (_ctx.contactTag)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("img", {
              class: "closed",
              src: _imports_9,
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.contactTag = 0)),
              alt: "closed"
            }),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createVNode(_component_el_input, {
                      class: "name-input",
                      modelValue: _ctx.firstName,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.firstName) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createVNode(_component_el_input, {
                      class: "name-input",
                      modelValue: _ctx.lastName,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.lastName) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_component_el_input, {
                    class: "email-input",
                    modelValue: _ctx.emailAddress,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.emailAddress) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createVNode(_component_el_input, {
                    class: "content-input",
                    type: "textarea",
                    resize: "none",
                    rows: 6,
                    modelValue: _ctx.content,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.content) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    plain: "",
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.getMessage()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_29
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_BackTop),
    _createVNode(_component_ChatBox),
    _createVNode(_component_Footer),
    _createVNode(_component_CookieBox)
  ]))
}